{
  "info": "情報",
  "negative": "エラー",
  "positive": "成功"
}
